import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function opportunitiesReducer(state = initialState.opportunities, action) {
  switch (action.type) {
    case types.FETCH_OPPORTUNITIES:
      return Object.assign({}, state, {
        loading: true
      });
    case types.FETCH_OPPORTUNITIES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data.records
      });
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/opportunitiesReducer.js